import React from "react";
// import whiteLogo from "../assests/newbrand/14.svg";
// import blueLogo from "../assests/newbrand/13.svg";

import whiteLogo from "../assests/newbrand/logo-white.webp";
import blueLogo from "../assests/newbrand/logo.webp";
import { useThemeMode } from "../context/ThemeContext";
import { useBranding } from "../context/BrandingContext";

// const sizeMap = {
//   sm: "w-20 md:w-40",
//   md: "w-50 md:w-40",
//   lg: "w-50 md:w-30",
// };

const sizeMap = {
  sm: "w-24 md:w-35",   // 80px → 128px
  md: "w-28 md:w-40",   // 112px → 160px
  lg: "w-36 md:w-48",   // 144px → 192px
};

const BrandLogo = ({
  variant = "auto",
  size = "md",
  className = "",
  alt,
}) => {
  const { mode } = useThemeMode();
  const { settings, mediaUrl, companyName } = useBranding();

  const preferDark = variant === "white" || (variant === "auto" && mode === "dark");
  const remote = preferDark
    ? settings?.logoDarkUrl || settings?.logoLightUrl
    : settings?.logoLightUrl || settings?.logoDarkUrl;

  const logoSrc = remote
    ? mediaUrl(remote)
    : preferDark
      ? whiteLogo
      : blueLogo;

  return (
    <img
      src={logoSrc}
      alt={alt || companyName || "Brand Logo"}
      loading="lazy"
      className={`object-contain ${sizeMap[size] || sizeMap.md} ${className}`}
    />
  );
};

export default BrandLogo;
